import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLtlWizardFormChangeTracking = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLtlWizardFormChangeTracking);
};
